import { Component } from 'react'
// @ts-ignore
import Select from 'react-select'
import { getNominative } from '../../common/utils'
import Modal from '.'
import PopupModal from './PopupModal'

interface Zone {
  id: string
  name: string
}

interface Resident {
  id: string
  name: {
    first: string
    last: string
  }
  zone: string
  // Define other properties
}

interface EditResidentZoneModalProps {
  fields: Resident
  isOpen: boolean
  zones: Zone[]
  updateItem: (data: any) => void
  setFormField: (data: { key: string; value: any }) => void
  fetchList: (list: string) => void
  showToast: (options: { title: string }) => void
  features: {
    preferredPeopleNominative: string
    // Define other feature properties
  }
}

export class EditResidentZoneModal extends Component<EditResidentZoneModalProps> {
  handleChange = (id: string) => {
    this.props.setFormField({ key: 'zone', value: id })
  }

  handleSubmit = () => {
    const { fields, updateItem, setFormField } = this.props

    if (fields.zone === 'Unassigned') {
      setFormField({ key: 'zone', value: null })
    }
    updateItem({
      url: `list/residents/${fields.id}`,
      onComplete: this.handleComplete
    })
  }

  handleComplete = () => {
    const { fetchList, showToast, features } = this.props
    showToast({
      title: `Updated a ${getNominative(
        features.preferredPeopleNominative,
        'Resident'
      )}'s Zone`
    })
    fetchList('zones')
    fetchList('residents')
  }

  render() {
    const { fields, isOpen, zones, ...formProps } = this.props

    if (!isOpen) return null
    const modalTitle = `${fields.name.first} ${fields.name.last}'s Zone`
    return (
      <PopupModal
        confirmText="Save"
        buttonColour="success"
        buttonIcon="CheckOutlined"
        list={modalTitle}
        onConfirm={this.handleSubmit}
        style={{ overflowY: 'inherit' }}
        type="edit"
        {...formProps}
      >
        <Select
          classNamePrefix="lmc-select"
          // @ts-ignore
          getOptionLabel={({ name }) => name}
          // @ts-ignore
          getOptionValue={({ id }) => id}
          options={zones}
          // @ts-ignore
          onChange={({ id }) => this.handleChange(id)}
          value={
            fields.zone
              ? zones.filter(({ id }) => id === fields.zone)
              : { id: 'Unassigned', name: 'Unassigned' }
          }
        />
      </PopupModal>
    )
  }
}

export default Modal(EditResidentZoneModal, 'editResidentZone')
